//--------------
// cast to type
//--------------
export default function castToType(reference, value) {
  if (value === null || value === undefined) {
    return value
  }

  const refType = typeof reference
  if (refType === 'number') {
    // Handle NaN gracefully
    const num = Number(value)
    return isNaN(num) ? reference : num
  }
  if (refType === 'boolean') {
    // Accept 'true', 'false', 1, 0, etc.
    if (typeof value === 'string') {
      return value.toLowerCase() === 'true'
    }
    return Boolean(value)
  }
  if (refType === 'string') {
    return String(value)
  }
  if (refType === 'object') {
    // For arrays and objects, just return as is (or use deep clone if needed)
    return value
  }
  // Default: return value as is
  return value
}
